import { render, staticRenderFns } from "./SimMayMan.vue?vue&type=template&id=595cb644"
import script from "./SimMayMan.vue?vue&type=script&lang=js"
export * from "./SimMayMan.vue?vue&type=script&lang=js"
import style0 from "./SimMayMan.vue?vue&type=style&index=0&id=595cb644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports